import {
  Routes,
  Route,
  Navigate,
  RouteProps,
  RoutesProps,
} from "react-router-dom";

import React, { Suspense, useEffect } from "react";
import { useState } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-circular-progressbar/dist/styles.css';
import Chapter from "../pages/Chapter/Chapter";
import SubscriptionPlans from "../components/SubscriptionPlans/SubscriptionPlans";
import Settings from "../pages/Settings/Settings";
import Studydetails from "../pages/Studydetails/Studydetails";
import Mysubscription from "../pages/Mysubscription/Mysubscription";
import Joinexam from "../pages/Joinexam/Joinexam";
import Contact from "../pages/Contact/Contact";
import Terms from "../pages/Terms/Terms";

const Navigation = () => {

  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(
    () => import("../components/Login/Login")
  );
  const Signup = React.lazy(
    () => import("../components/Signup/Signup")
  );
  const Otp = React.lazy(
    () => import("../components/Otp/Otp")
  );
  const ForgotPassword = React.lazy(
    () => import("../components/Login/ForgotPassword")
  );
  const SubscriptionPlans = React.lazy(
    () => import("../components/SubscriptionPlans/SubscriptionPlans")
  );
  

  const Dashboard = React.lazy(
    () => import("../pages/Dashboard/Dashboard")
  );
  const ExamManagement = React.lazy(
    () => import("../pages/ExamManagement/ExamManagement")
  );
  const Chapter = React.lazy(
    () => import("../pages/Chapter/Chapter")
  );
  const Payment = React.lazy(
    () => import("../pages/Payment/Payment")
  );
  const Profile = React.lazy(
    () => import("../pages/Profile/Profile")
  );
  const joinexam = React.lazy(
    () => import("../pages/Joinexam/Joinexam")
  );
  const Examcompleted = React.lazy(
    () => import("../pages/Examcompleted/Examcompleted")
  );
  const Settings = React.lazy(
    () => import("../pages/Settings/Settings")
  );
  const Contact = React.lazy(
    () => import("../pages/Contact/Contact")
  );
  const Buy = React.lazy(
    () => import("../pages/Buy/Buy")
  );
  const About = React.lazy(
    () => import("../pages/About/About")
  );
  const Privacy = React.lazy(
    () => import("../pages/Privacy/Privacy")
  );
  const Examdetails = React.lazy(
    () => import("../pages/Examdetails/Examdetails")
  );
  

  const Terms = React.lazy(
    () => import("../pages/Terms/Terms")
  );
  
  
  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route
            path="/login"
            element={
              <Suspense fallback={<></>}>
                <Login />
              </Suspense>
            }
          />
          <Route
            path="/signup"
            element={
              <Suspense fallback={<></>}>
                <Signup />
              </Suspense>
            }
          />
          <Route
              path="/otp"
              element={
                <Suspense fallback={<></>}>
                  <Otp />
                </Suspense>
              }
            />
             <Route
              path="/subscriptionplans"
              element={
                <Suspense fallback={<></>}>
                  <SubscriptionPlans />
                </Suspense>
              }
            />


           <Route
            path="/forgotPassword"
            element={
              <Suspense fallback={<></>}>
                <ForgotPassword />
              </Suspense>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={<Main />}
              />
            }
          >
            
            <Route
              path="/exammanagement"
              element={
                <Suspense fallback={<></>}>
                  <ExamManagement />
                </Suspense>
              }
            />
             <Route
              path="/payment"
              element={
                <Suspense fallback={<></>}>
                  <Payment />
                </Suspense>
              }
            />
             <Route
              path="/profile"
              element={
                <Suspense fallback={<></>}>
                  <Profile />
                </Suspense>
              }
            />

<Route
              path="/chapter"
              element={
                <Suspense fallback={<></>}>
                  <Chapter />
                </Suspense>
              }
            />

             <Route
              path="/joinexam"
              element={
                <Suspense fallback={<></>}>
                  <Joinexam />
                </Suspense>
              }
            />

            <Route
              path="/examcompleted"
              element={
                <Suspense fallback={<></>}>
                  <Examcompleted />
                </Suspense>
              }
            />
             <Route
              path="/mysubscription"
              element={
                <Suspense fallback={<></>}>
                  <Mysubscription />
                </Suspense>
              }
            />
            <Route
              path="/settings"
              element={
                <Suspense fallback={<></>}>
                  <Settings />
                </Suspense>
              }
            />

<Route
              path="/buy"
              element={
                <Suspense fallback={<></>}>
                  <Buy />
                </Suspense>
              }
            />
             
             
             <Route
              path="/settings"
              element={
                <Suspense fallback={<></>}>
                  <Settings />
                </Suspense>
              }
            />
            <Route
              path="/contact"
              element={
                <Suspense fallback={<></>}>
                  <Contact/>
                </Suspense>
              }
            />
             <Route
              path="/about"
              element={
                <Suspense fallback={<></>}>
                  <About/>
                </Suspense>
              }
            />
             <Route
              path="/privacy"
              element={
                <Suspense fallback={<></>}>
                  <Privacy/>
                </Suspense>
              }
            />
             <Route
              path="/terms"
              element={
                <Suspense fallback={<></>}>
                  <Terms/>
                </Suspense>
              }
            />
             <Route
              path="/examdetails"
              element={
                <Suspense fallback={<></>}>
                  <Examdetails/>
                </Suspense>
              }
            />
            
            
            
            <Route
              path="/dashboard"
              element={
                <Suspense fallback={<></>}>
                  <Dashboard />
                </Suspense>
              }
            />
          </Route>
          
          
        </Routes >
      </div >
    </>
  );
};

export default Navigation;
